var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"flixFadeIn"}},[(_vm.open)?_c('div',{key:_vm.open,staticClass:"flix-popup"},[_c('div',{staticClass:"flix-popup-content"},[(_vm.type === 'warning')?_c('div',{staticClass:"flix-popup-icon flix-text-danger"},[_c('flixIcon',{attrs:{"id":'warning-sign'}})],1):_vm._e(),_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }